/**
 * Ассеты мини-игры «Правильный плов» по вариантам казана.
 *
 * У каждого пака:
 * - `id` — стабильный ключ (совпадает с ключами в riceGamePacksById).
 * - `backgroundDesktop` / `backgroundMobile` — фон сцены (1x).
 * - Опционально `backgroundDesktop2x` / `backgroundMobile2x` — ретина (`@2x` в имени файла).
 * - `frames` — кадры по клику на **десктопе** (порядок = порядок кликов).
 * - Опционально `framesMobile` — отдельные кадры для **узкой ширины** (как у turkish: `state_mobile_*`).
 * - Опционально `introBackground*` — экран правил; если не заданы — берутся из `background*`.
 *
 * Файлы кладите в `src/assets/img/rice-game/packs/<id>/`, импорты — в `riceGamePacks/*Assets.js`.
 */
import gameReady from '@/assets/img/rice-game/game-start-bg@2x.png';
import {
  biryaniBackgrounds,
  biryaniFramesDesktop,
  biryaniFramesMobile,
} from '@/config/riceGamePacks/biryaniAssets';
import {
  chayhanskiyBackgrounds,
  chayhanskiyFramesDesktop,
  chayhanskiyFramesMobile,
} from '@/config/riceGamePacks/chayhanskiyAssets';
import {
  domashniyBackgrounds,
  domashniyFramesDesktop,
  domashniyFramesMobile,
} from '@/config/riceGamePacks/domashniyAssets';
import {
  turkishBackgrounds,
  turkishFramesDesktop,
  turkishFramesMobile,
} from '@/config/riceGamePacks/turkishAssets';
import {
  uzbekBackgrounds,
  uzbekFramesDesktop,
  uzbekFramesMobile,
} from '@/config/riceGamePacks/uzbekAssets';
import {
  vostochniyBackgrounds,
  vostochniyFramesDesktop,
  vostochniyFramesMobile,
} from '@/config/riceGamePacks/vostochniyAssets';

/** Заглушка, пока не подключены фоны из Figma (одинаковый фон + несколько шагов). */
const placeholderBg = gameReady;

/** Сколько шагов по умолчанию (можно заменить реальными кадрами). */
function makePlaceholderFrames(count) {
  return Array.from({ length: count }, () => gameReady);
}

export const riceGameDefaultPack = {
  id: 'default',
  backgroundDesktop: placeholderBg,
  backgroundMobile: placeholderBg,
  frames: makePlaceholderFrames(10),
};

/**
 * Ключ → пак. Ключ выбирается в resolveRiceGameAssetPack по title / rice_type.
 */
export const riceGamePacksById = {
  domashniy: {
    id: 'domashniy',
    matchTitles: ['по-домашнему', 'домашн'],
    ...domashniyBackgrounds,
    frames: domashniyFramesDesktop,
    framesMobile: domashniyFramesMobile,
  },
  biryani: {
    id: 'biryani',
    matchTitles: ['бирияни', 'biryani'],
    ...biryaniBackgrounds,
    frames: biryaniFramesDesktop,
    framesMobile: biryaniFramesMobile,
  },
  uzbek: {
    id: 'uzbek',
    matchTitles: ['по-узбекски', 'узбек'],
    ...uzbekBackgrounds,
    frames: uzbekFramesDesktop,
    framesMobile: uzbekFramesMobile,
  },
  turkish: {
    id: 'turkish',
    matchTitles: ['по-турецки', 'турец'],
    ...turkishBackgrounds,
    frames: turkishFramesDesktop,
    framesMobile: turkishFramesMobile,
  },
  vostochniy: {
    id: 'vostochniy',
    matchTitles: ['по-восточному', 'восточн'],
    ...vostochniyBackgrounds,
    frames: vostochniyFramesDesktop,
    framesMobile: vostochniyFramesMobile,
  },
  chayhanskiy: {
    id: 'chayhanskiy',
    matchTitles: ['чайханск', 'чайхан'],
    ...chayhanskiyBackgrounds,
    frames: chayhanskiyFramesDesktop,
    framesMobile: chayhanskiyFramesMobile,
  },
};
